export default "__VITE_ASSET__BPd0yMtY__"